import { useEffect, useState } from "react";
import Slider from "react-slick";
import { getAllRealEstate } from "../../services/kojaServices";
import { downloadUrl } from "../../confing/confing";
import icon from "../../assets/م ا ک-0۱.png"
import { toast } from "react-hot-toast";

const RealEstate = () => {

  const [realEstates, setRealEstates] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getAllRealEstate();
        console.log(data);
        setRealEstates(data.result)
      } catch (err) {
        console.log(err);
        toast.error("خطایی رخ داده است مجدد تلاش کنید")
      }
    };
    fetchData();
  }, []);

  const settings = {
    customPaging: function(i) {
      return (
        <p>
        <img className=''  alt="product" width={40} height={30} src={`${downloadUrl}${realEstates[i].pic}`} />
        </p>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    rtl: true,
    nextArrow: <p></p>,
    prevArrow: <p></p>,
  };


  return (
    <div className="koja-realestate justify-content-center justify-content-md-start">
      <div
        className="black-strip2 d-none d-md-flex justify-content-center align-items-center"
        style={{ marginRight: "75px" }}
      >
      <div>
      <img alt="" src={icon} className="realstate-icon"/>
      </div>
      </div>
      <div className="experts-box m-auto" >
        { realEstates.length >0 && 
          <div className="realsate-box">
          <div className="realstate-item-box">
            <Slider {...settings}>
              {realEstates.map((i, index) => (
                <div key={index}>
                  <img
                    alt=""
                    className="koja-experts-item-img"
                    src={`${downloadUrl}${i.agencyLogo}`}
                  />
                  <div className="koja-experts-item-content">
                    <strong>{i.name}</strong>
                    <div className="text-end  mt-2 ms-3 me-3">
                      <strong>مشاوره املاک : </strong>
                      <p className="d-inline"> {i.agencyName} </p>
                    </div>
                    <div className="text-end  mt-2 ms-3 me-3">
                      <strong>آدرس بنگاه:</strong>
                      <p className="d-inline">
                        {" "}
                        {i.agencyAddress.substring(0, 100)}
                      </p>
                    </div>
                    <div className="text-end  mt-2 ms-3 me-3">
                      <strong>شماره تماس : </strong>
                      <p className="d-inline"> {i.tel}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        }
      </div>
     
    </div>
  );
};

export default RealEstate;
